/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Borrower contract information
 * @export
 * @interface BorrowerContractDto
 */
export interface BorrowerContractDto {
    /**
     * Unique identifier of the contract
     * @type {string}
     * @memberof BorrowerContractDto
     */
    id: string;
    /**
     * Contract number
     * @type {string}
     * @memberof BorrowerContractDto
     */
    contractNumber: string;
    /**
     * Contract status label
     * @type {string}
     * @memberof BorrowerContractDto
     */
    status: string;
    /**
     * Contract status code
     * @type {string}
     * @memberof BorrowerContractDto
     */
    statusCode: string;
    /**
     * Effective start date of the contract
     * @type {Date}
     * @memberof BorrowerContractDto
     */
    effectiveDate?: Date | null;
    /**
     * End date of the contract
     * @type {Date}
     * @memberof BorrowerContractDto
     */
    endDate?: Date | null;
    /**
     * Product code
     * @type {string}
     * @memberof BorrowerContractDto
     */
    productCode: string;
    /**
     * Product label
     * @type {string}
     * @memberof BorrowerContractDto
     */
    productLabel: string;
}

/**
 * Check if a given object implements the BorrowerContractDto interface.
 */
export function instanceOfBorrowerContractDto(value: object): value is BorrowerContractDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('productCode' in value) || value['productCode'] === undefined) return false;
    if (!('productLabel' in value) || value['productLabel'] === undefined) return false;
    return true;
}

export function BorrowerContractDtoFromJSON(json: any): BorrowerContractDto {
    return BorrowerContractDtoFromJSONTyped(json, false);
}

export function BorrowerContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractNumber': json['contractNumber'],
        'status': json['status'],
        'statusCode': json['statusCode'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'productCode': json['productCode'],
        'productLabel': json['productLabel'],
    };
}

export function BorrowerContractDtoToJSON(json: any): BorrowerContractDto {
    return BorrowerContractDtoToJSONTyped(json, false);
}

export function BorrowerContractDtoToJSONTyped(value?: BorrowerContractDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contractNumber': value['contractNumber'],
        'status': value['status'],
        'statusCode': value['statusCode'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'productCode': value['productCode'],
        'productLabel': value['productLabel'],
    };
}

